import {
    AfterContentInit,
    AfterViewInit,
    Component,
    ContentChildren,
    EventEmitter,
    Input, OnChanges,
    OnInit,
    Output,
    QueryList, SimpleChanges
} from '@angular/core';
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {BandejaBaseComponent} from "../bandeja-base/bandeja-base.component";
import {v4 as uuidv4} from 'uuid';
import {Subject} from "rxjs";
import {first} from "rxjs/operators";
import {EvkSecurityControlDataService} from "@evomatik/evk-seguridad";
import {MatDialog} from "@angular/material/dialog";
import {ContenedorFormatosComponent} from "../contenedor-formatos/contenedor-formatos.component";
import {ContenedorAdjuntarComponent} from "../contenedor-adjuntar/contenedor-adjuntar.component";

@Component({
    selector: 'contenedor-base',
    templateUrl: `./contenedor-base.component.html`,
    styleUrls: ['./contenedor-base.component.css']
})
export class ContenedorBaseComponent implements OnInit, AfterContentInit, OnChanges {

    @ContentChildren(BandejaBaseComponent) templates: QueryList<BandejaBaseComponent<any>>;

    @Input()
    listaElementos: any[];

    @Input()
    config: PasoWizard;

    @Input()
    readOnly: boolean = false;

    @Output()
    actualizar: EventEmitter<any> = new EventEmitter<any>();

    isEdit = false;
    isAdd = false;
    isPage = true;

    form: FormGroup = new FormGroup({});
    doneForm: Subject<boolean> = new Subject<boolean>();

    constructor(
        private evkSecurity: EvkSecurityControlDataService,
        public dialog: MatDialog
    ) {
    }

    ngAfterContentInit() {
        this.templates.get(0).actionTrigger.subscribe((data) => this.onAction(data));
        this.templates.get(0).data$.next(this.listaElementos);
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['listaElementos'] && !changes['listaElementos'].firstChange) {
            this.templates.get(0).data$.next(this.listaElementos);
        }
    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    goBack() {
        this.isEdit = this.isAdd = false;
        this.isPage = true;
        this.form.reset();
    }

    onAction(data: Record<string, any>) {
        switch (Object.keys(data)[0]) {
            case 'ADD': {
                this.form = new FormGroup({});
                this.isAdd = true;
                this.isEdit = this.isPage = false;
                break;
            }
            case 'EDIT': {
                this.form = new FormGroup({});
                this.isAdd = this.isPage = false;
                this.isEdit = true;
                this.doneForm.pipe(first()).subscribe(() => {
                    this.form.addControl('uuid', new FormControl(data['EDIT']['uuid'], Validators.required));
                    // this.form.patchValue(data['EDIT']);
                    setTimeout(() => {
                        this.form.patchValue(data['EDIT']);
                        if(this.readOnly){
                            this.form.disable();
                        }
                    });
                });
                break;
            }
            case 'DELETE': {
                this.deleteItem(data['DELETE']);
                break;
            }
            case 'FORMATO': {
                this.openContenedorFormatos(data['FORMATO']);
                break;
            }
            case 'ADJUNTAR': {
                this.openContenedorAdjuntar(data['ADJUNTAR']);
                break;
            }
        }
    }

    onSave(data: any) {
        if (this.isAdd) {
            this.agregarItemLista(data);
        } else {
            this.actualizarItemLista(data);
        }
        this.actualizar.emit(this.listaElementos);
        this.templates.get(0).data$.next(this.listaElementos);
        this.goBack();
    }

    agregarItemLista(data: any) {
        /**
         * Se agrega un uuid para poder actualizar los elementos del arreglo
         */
        data['uuid'] = uuidv4();
        data['created'] = new Date();
        data['updated'] = new Date();
        data['createdBy'] = this.evkSecurity.getUsuarioInfo().username;
        data['createdByFullName'] = this.evkSecurity.getUsuarioInfo().nombreCompleto;
        data['updatedBy'] = this.evkSecurity.getUsuarioInfo().username;
        data['updatedByFullName'] = this.evkSecurity.getUsuarioInfo().nombreCompleto;
        this.listaElementos.push(data);
    }

    actualizarItemLista(data: any) {
        data['updated'] = new Date();
        data['updatedBy'] = this.evkSecurity.getUsuarioInfo().username;
        data['updatedByFullName'] = this.evkSecurity.getUsuarioInfo().nombreCompleto;
        const indexObj = this.findIndex(data);
        if (indexObj != -1) {
            const before = this.listaElementos[indexObj];
            this.listaElementos[indexObj] = {...before, ...data};
        }
    }

    deleteItem(data: any) {
        const indexObj = this.findIndex(data);
        if (indexObj != -1) {
            this.listaElementos.splice(indexObj, 1);
        }
        this.actualizar.emit(this.listaElementos);
        this.templates.get(0).data$.next(this.listaElementos);
    }

    findIndex(data: any): number {
        return this.listaElementos.findIndex(element => element.uuid === data.uuid);
    }

    onDoneForm(value: boolean) {
        this.doneForm.next(value);
    }

    openContenedorFormatos(data: any) {
        this.dialog.open(ContenedorFormatosComponent, {
            disableClose: true,
            data: {
                uuid: data.uuid,
                formatos: data.formatos
            }
        });
    }

    openContenedorAdjuntar(data: any) {
        this.dialog.open(ContenedorAdjuntarComponent, {
            disableClose: true,
            data: {
                uuid: data.uuid
            }
        });
    }
}
